import postscribe from './postscribe';

module.exports = postscribe;




/** WEBPACK FOOTER **
 ** ./src/main.js
 **/